import { Component } from '@angular/core';

@Component({
    template: '',
    standalone: false
})
export class LandingComponent {}
